import React from "react";
import MyCard7 from "./MyCard7";
import { MyColors } from "../util/my_colors";
import YouTubeIcon from "@mui/icons-material/YouTube";
import MyCard10 from "./MyCard10";
import { CalendarDays, ChevronRight, Clapperboard, TvMinimalPlay, UserRoundPlus } from "lucide-react";

export default function YtCard({ className ,subscriberCount,videoCount,viewCount,joinedDate}) {
  return (
    <MyCard7 className={` ${className}`}>
      <div className="flex flex-col">
        <div className="flex items-center justify-start space-x-3 ">
          {/* <YouTubeIcon
          className={`mr-2  ${MyColors.red.text}`}
          sx={{ fontSize: 24 }}
          /> */}
          <img
            className="h-10 w-10 rounded-full object-cover border border-slate-400"
            src="https://yt3.googleusercontent.com/I2Tkd8wRlIDsnqhVXAmZSaUeivyJSwb7iQVysBDJgq2Q4a2wLPIftS3LgP1QfMWQbBPre4vBmg=s900-c-k-c0x00ffffff-no-rj"
            alt=""
          />

          <span className="text-xl text-red-600 font-bold tracking-wider font-sans dark:text-red-600">
            SFE Tech
          </span>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 items-start justify-start mt-4">
          <MyCard10
            label={"Subscribers"}
            value={subscriberCount}
            icon={UserRoundPlus}
            iconColor={"#c70f0f"}
          />
          <MyCard10
            label={"Videos"}
            value={videoCount}
            icon={Clapperboard}
            iconColor={"#0f5cc7"}
          />
          <MyCard10
            label={"Views"}
            value={viewCount}
            icon={TvMinimalPlay}
            iconColor={"#b10fc7"}
          />
          <MyCard10
            label={"Joined"}
            value={joinedDate}
            icon={CalendarDays}
            iconColor={"#438914"}
          />
        </div>
      </div>
    </MyCard7>
  );
}
